import * as tslib_1 from "tslib";
import { Apollo } from 'apollo-angular';
import { map } from 'rxjs/operators';
import { QuerifyService } from '../services/querify.service';
import { Queries } from './graphql/queries';
import * as i0 from "@angular/core";
import * as i1 from "apollo-angular";
import * as i2 from "./graphql/queries";
import * as i3 from "../services/querify.service";
var MaintenanceTypeApi = /** @class */ (function () {
    function MaintenanceTypeApi(apollo, queries, querify) {
        this.apollo = apollo;
        this.queries = queries;
        this.querify = querify;
    }
    MaintenanceTypeApi.prototype.search = function (query, options) {
        options = this.querify.transformOptions(query, options);
        return this.apollo
            .query({
            query: this.queries.maintenanceTypesPaginated(),
            variables: options
        })
            .pipe(map(function (_a) {
            var data = _a.data;
            return data['maintenanceTypes'];
        }));
    };
    MaintenanceTypeApi.prototype.searchOne = function (maintenanceTypeId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.apollo.query({
                        query: this.queries.searchMaintenanceType(),
                        variables: { id: maintenanceTypeId }
                    }).toPromise()
                        .then(function (_a) {
                        var data = _a.data;
                        return data['maintenanceType'];
                    })];
            });
        });
    };
    MaintenanceTypeApi.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MaintenanceTypeApi_Factory() { return new MaintenanceTypeApi(i0.ɵɵinject(i1.Apollo), i0.ɵɵinject(i2.Queries), i0.ɵɵinject(i3.QuerifyService)); }, token: MaintenanceTypeApi, providedIn: "root" });
    return MaintenanceTypeApi;
}());
export { MaintenanceTypeApi };
